import React, { useEffect, useState } from 'react';
import { bgMembers, tableBenefits } from 'assets';
import { Button, Loading, Modal, Picture } from 'components/UI';
import PropTypes from 'prop-types';
import {
  membershipBenefits,
  experienceOptions,
} from 'utils/constants';
import { bgNewMembershipBanner } from 'assets';
import { BackgroundSection } from '../../LandingPage/common';
import TierInfoCard from '../../Membership/TierInfoCard';
import ExperienceFilter from '../../Membership/ExperienceFilter';
import MembershipCard from 'containers/Membership/MembershipCard';
import { useSelector } from 'react-redux';
import Selectors from 'selectors';
import Actions from 'actions';

const ChooseTiers = ({
  memberTiers = [],
  setLiteOnly,
  liteOnly = false,
  getPrice,
  getMinPrice,
  showNextScreen,
  selectedBillingCycle,
  setSelectedBillingCircle,
}) => {
  const isLoadingTiers = useSelector(
    Selectors.createLoadingSelector([Actions.FETCH_MEMBER_TIERS_REQUEST])
  );
  
  const sortedTiers = memberTiers.sort((tier1, tier2) => {
    return getMinPrice(tier1.prices) - getMinPrice(tier2.prices);
  });

  const [activeTab, setActiveTab] = useState(
    experienceOptions[experienceOptions.length - 1]
  );
  const handleTabChange = (experience) => {
    setActiveTab(experience);
    setLiteOnly(experience !== experienceOptions[experienceOptions.length - 1]);
  };

  return (
    <>
      <BackgroundSection
        backgroundImage={`url(${bgNewMembershipBanner.default})`}
        className="relative flex flex-col bg-no-repeat bg-cover pt-20 pb-20 px-2"
      >
        <ExperienceFilter
          handleTabChange={handleTabChange}
          activeTab={activeTab}
        />
        <div className="flex flex-col items-center max-w-6xl mx-auto my-12 px-4 relative z-10">
          <div className="flex flex-col-reverse space-y-3 md:space-y-0 lg:px-3 justify-center" style={{ gap: '1rem' }}>
            {
              isLoadingTiers ? (
                <div className='flex justify-center items-center'>
                  <Loading className='w-10 h-10 mb-5' />
                </div>
              ) : (
                sortedTiers.map((tier) => (
                  <MembershipCard
                    key={tier.id}
                    memberTier={tier?.name}
                    selectedPlan={selectedBillingCycle}
                    setSelectedPlan={setSelectedBillingCircle}
                    monthlyPrice={getPrice(tier, 'month')}
                    annualPrice={getPrice(tier, 'year')}
                    isAllAccessEligible={!liteOnly}
                    showNextScreen={showNextScreen}
                    benefits={membershipBenefits[tier?.name]}
                  />
                ))
              )
            }
          </div>
          <div className="flex justify-center mt-6" style={{ gap: '0.25rem' }}>
            <Modal content={<Picture src={tableBenefits} />} className="bg-black-cover z-50">
              <span className="text-easter cursor-pointer">See a full list of our features.</span>
            </Modal>
          </div>
        </div>
      </BackgroundSection>
    </>
  );
};

ChooseTiers.propTypes = {
  memberTiers: PropTypes.array.isRequired,
  setLiteOnly: PropTypes.func.isRequired,
  liteOnly: PropTypes.bool.isRequired,
  getPrice: PropTypes.func.isRequired,
  getMinPrice: PropTypes.func.isRequired,
  showNextScreen: PropTypes.func.isRequired,
};

export default ChooseTiers;
